<div class="modal-box-large">
  <div class="d-flex flex-column justify-content-start">
    <h4>Referente da Modificare</h4>
  </div>
  <app-basic-form
    [form]="modifyReferentForm"
    [keys]="modifyReferentFormKeys"
  ></app-basic-form>
  <div class="d-flex justify-content-end mt-3">
    <button
      mat-raised-button
      color="primary"
      class="mx-3"
      (click)="onConfirmSelection()"
      [disabled]="!modifyReferentForm.valid"
    >
      Conferma
    </button>
    <button mat-button color="warn" class="mx-3" (click)="onCancelSelection()">
      Annulla
    </button>
  </div>
</div>
